import { useQuery } from 'react-query';
import { CircularProgress } from '@mui/material';

import { AdminDashboardApi } from '@app/domain/dashboard/api/AdminDashboardApi';

import { DashboardTile } from './DashboardTile';
import { DASHBOARD_COLOR } from '../shared/dashboardColors';

// admin-dashboard-opdracht.md §4.2 (band 1) - found live on dev 2026-08-24 (Danny): the tiles
// didn't move with the period selector, which was a bug. from===to===today (the "Vandaag"
// preset's own from/to, see useDashboardPeriod) keeps the backend's original live "vandaag"
// tiles; any other period aggregates instead - see AdminDashboardFacadeImpl's own javadoc.
export const DashboardTilesBand: React.FC<{ from: string; to: string }> = ({ from, to }) => {
  const query = useQuery(['admin-dashboard-tiles', from, to], () => AdminDashboardApi.getTiles(from, to));

  if (query.isLoading) {
    return (
      <div className="flex h-[140px] items-center justify-center">
        <CircularProgress />
      </div>
    );
  }

  if (!query.data) {
    return null;
  }

  const { signupsToday, scansToday, activeTrials, payingCustomers } = query.data;

  return (
    <div className="grid grid-cols-2 gap-3.5 md:grid-cols-4">
      <DashboardTile tile={signupsToday} color={DASHBOARD_COLOR.cat1} to={to} />
      <DashboardTile tile={scansToday} color={DASHBOARD_COLOR.cat2} to={to} />
      <DashboardTile tile={activeTrials} color={DASHBOARD_COLOR.cat3} to={to} />
      <DashboardTile tile={payingCustomers} color={DASHBOARD_COLOR.cat4} to={to} />
    </div>
  );
};
